export default "__VITE_ASSET__72ab0007__"